import jQuery from "jquery";
import escapeRegex from "../utilities/escapeRegex.js";
import isPlaceholder from "./isPlaceholder.js";
import isFocused from "./isFocused.js";

const toggleHighlight = (element, highlight) => {
    if (!element || element.dataset.theme === 'snow' || isPlaceholder(element) || isFocused(element)) return;

    const quill = element.querySelector('.ra-quill');

    if (highlight) {
        const regex = new RegExp('(' + escapeRegex(highlight) + ')', 'gi');
        quill.innerHTML = quill.innerHTML.replace(regex, '<span class="bg-yellow-200">$1</span>');
    } else {
        const $element = jQuery(quill);
        $element.find('.bg-yellow-200').contents().unwrap();
    }
};

export default toggleHighlight;
